import * as React from "react";
import ReactModal from "react-modal";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

interface Props extends React.PropsWithChildren {
  className?: string;
  text: string;
  title: string;
  modalVisible: boolean;
  allowContentOverflow?: boolean;
  shouldCloseOnEsc?: boolean;
  setModalVisible: (visible: boolean) => void;
  disabled?: boolean;
}

const ContentHeader = styled.div`
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;

  & > .title {
    padding: 0.25rem 0.5rem;
    font-size: 0.9rem;
    font-weight: bold;
  }
`;

const CloseButton = styled.div`
  cursor: pointer;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.1s ease-out;

  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
    transition: none;
  }
`;

const Wrapper = styled.div`
  display: inline-block;
  position: relative;
`;

const ContentWrapper = styled.div`
  & > .content {
    padding: 0.5rem;
  }
`;

const ModalButton = ({
  className,
  children,
  text,
  title,
  modalVisible,
  allowContentOverflow,
  shouldCloseOnEsc,
  setModalVisible,
  disabled,
}: Props) => {
  const showModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const modalStyle: ReactModal.Styles = {
    overlay: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1001, // menu bar is 1000
      backgroundColor: "rgba(0, 0, 0, 0.3)",
    },
    content: {
      position: "relative",
      padding: 0,
      boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
      overflow: allowContentOverflow ?? false ? "unset" : "auto",
      inset: 0,
      maxWidth: "calc(100% - 1rem)",
    },
  };

  return (
    <Wrapper>
      <a
        className={classNames(className, disabled && "disabled")}
        onClick={() => !disabled && showModal()}
      >
        {text}
      </a>
      <ReactModal
        isOpen={modalVisible}
        ariaHideApp={false}
        shouldCloseOnEsc={shouldCloseOnEsc}
        shouldCloseOnOverlayClick={true}
        onRequestClose={closeModal}
        style={modalStyle}
      >
        <ContentWrapper>
          <ContentHeader>
            <div className="title">{title}</div>
            <CloseButton onClick={closeModal} title="Stäng">
              <FontAwesomeIcon icon={faClose} />
            </CloseButton>
          </ContentHeader>
          <div className="content">{children}</div>
        </ContentWrapper>
      </ReactModal>
    </Wrapper>
  );
};

export default ModalButton;
